import { useEffect, useState } from 'preact/hooks';

export const useSubscribe = (store) => {
  const [state, setState] = useState(store.getValue());
  useEffect(() => {
    const subscription = store.subscribe(setState);
    return () => subscription.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return state;
};
